import type { Editor } from "@tiptap/core";

export const getDirectiveSuggestionFloatingPanelClientRect = (args: {
  editor: Editor;
  suggestionClientRect: (() => DOMRect | null) | null;
  directiveTokenFrom: number | null;
}): (() => DOMRect | null) => {
  return (): DOMRect | null => {
    const direct = args.suggestionClientRect?.() ?? null;
    if (direct != null && direct.width > 0 && direct.height > 0) {
      return direct;
    }
    const pos = args.directiveTokenFrom;
    if (typeof pos !== "number" || pos < 0) {
      return direct;
    }
    try {
      const docSize = args.editor.state.doc.content.size;
      const safePos = Math.max(0, Math.min(pos, docSize));
      const c = args.editor.view.coordsAtPos(safePos);
      return new DOMRect(
        c.left,
        c.top,
        Math.max(1, c.right - c.left),
        Math.max(1, c.bottom - c.top),
      );
    } catch {
      return direct;
    }
  };
};
